import { Toast } from "@tandemdiabetes/sugarmate-react-components"
import { usePolyglot } from "src/contexts"

interface Props {
  id: string;
}

export function DuplicateEntrySuccessToast(props: Props) {
  const polyglot = usePolyglot()

  return (
    <Toast
      stylePreset="success"
      body={polyglot.t("toasts.duplicate_entry_success.body")}
      id={props.id}
    />
  )
}
